import axiosInstance from '../axiosConfigCMS';

export default {
  async getBanners() {
    const response = await axiosInstance.get('/faq-banners');
    return response.data;
  },
  async getContent() {
    const response = await axiosInstance.get('/faqs');
    return response.data;
  },
};
